// extracted by mini-css-extract-plugin
export default {"control":"style_control__G3q5s","screen":"style_screen__jZ30t"};